import React from "react";
import { Grid } from '@mui/material';
import PatientDashboard from "../../../components/ui/Patient/PatientDashboard";
import AppLayout from "../../SideBar";

const Patient = () => {
    return (
        <Grid container spacing={0}>
            <AppLayout>
                <PatientDashboard />
            </AppLayout>
        </Grid>
    )
}

export default Patient;